import {http, onSuccess, onFail} from './http';

export const getEventNotification = (id) =>
    http.get(`/api/player/event/notification/${id}`)
        .then(onSuccess, onFail);

export const eventNotificationClick = (id) =>
    http.post(`/api/player/event/notification/${id}/click`)
        .then(onSuccess, onFail);
